
import { Vue, Component } from "vue-property-decorator";
import KeepAlive from "vue";
import axios from "axios";
// Views
import OneBlockage from "@/views/OneBlockage/OneBlockage.vue";
import OrderDetail from "@/views/OrderDetail/OrderDetail.vue";
// Components
import { Navbar } from "@/components/index";
// Entities
import { Profile, Company } from "@/entities";

@Component({
  components: {
    Navbar,
    OneBlockage,
    OrderDetail,
  },
})
export default class App extends Vue {
  async getProfile(): Promise<Profile> {
    const profile = (await axios.get("/api/users/profile")).data as Profile;
    const userId = profile.id;
    await axios.post("/api/stats/action", { userId, action: "Connexion" });
    return profile;
  }

  async isAdmin(): Promise<unknown> {
    const profile = this.$store.state.profile;
    if (profile.role === "admin") {
      return true;
    } else if (profile.role === "standard") {
      return false;
    }
  }

  async getCompanySetting(id: number): Promise<Company> {
    return (await axios.get(`/api/companies/${id}`)).data as Company;
  }

  async getWarehouse(id: number): Promise<any> {
    return (await axios.get(`/api/warehouses/company/${id}`)).data as any;
  }

  async mounted(): Promise<void> {
    let profile = await this.getProfile();
    const settingCompany =
      (await this.getCompanySetting(profile.company.id)) ||
      profile.company.codeLogistic;
    profile.company.codeLogistic = settingCompany.codeLogistic;
    profile.company.optionPalette = settingCompany.optionPalette;
    let warehouse = await this.getWarehouse(profile.company.id);
    this.$i18n.locale = profile.lang;
    this.$store.commit("profile", profile);
    this.$store.commit("warehouse", warehouse[0].code);
    await this.$router.push("/dashboard");
  }
}
